__turbopack_context__.v({
  "innerRow": "OrderConfigureTimeInfo-module-scss-module__KWM0oG__innerRow",
  "row": "OrderConfigureTimeInfo-module-scss-module__KWM0oG__row",
  "spaceBetween": "OrderConfigureTimeInfo-module-scss-module__KWM0oG__spaceBetween",
});
